<div class="status-border-left" [class.plain]="approval && approval.status !== 'pending'"
    [class.green]="approval && approval.status === 'approved'" [class.red]="approval && approval.status === 'rejected'"
    [class.orange]="!approval || approval.status === 'pending'" [matTooltipClass]="{'uzai-tooltip':true}"
    [matTooltip]="(approval ? 'DOCUMENT.APPROVAL_'+approval.status.toUpperCase() : 'DOCUMENT.APPROVAL_PENDING') | translate">
</div>